import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { FavoritesDataService, FavoritesColumnsService } from '../../../services';
import { Favorite, FavoritesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-favorite-details',
  templateUrl: './favorite-details.component.html',
  styleUrls: ['./favorite-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class FavoriteDetailsComponent implements OnInit, OnDestroy {

  public favorite: Favorite = {};
  public favorites: Favorite[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private favoritesDataService: FavoritesDataService,
    private favoritesColumnsService: FavoritesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Favorite - Details');
        this.getFavorite(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.favorite !== 'undefined') {
      this.favorite = this.dynamicDialogConfig.data.favorite;
    }
    this.columns = this.favoritesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getFavorite(id: number): void {
    this.isLoading = true;
    this.favoritesDataService.getFavorite(id).subscribe((response: Favorite|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.favorite = response;
      }
    });
  }

  list() {
    this.router.navigate(['/favorites']);
  }

  add() {
    this.router.navigate(['/favorites/add']);
  }

  edit() {
    this.router.navigate(['/favorites/edit/' + this.favorite.id]);
  }

}
@Component({
  selector: 'app-favorite-details',
  templateUrl: './favorite-details.component.html',
  styleUrls: ['./favorite-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogFavoriteDetailsComponent extends FavoriteDetailsComponent {
}

